// An eine Frage springen (E3, S6): Ein Klick auf den Kunden auf der Seite
// „Fragen“ öffnet die Besichtigung an der Stelle, wo die Frage hängt; das
// Band oben in der Freigabe führt zur ersten offenen.
//
// Warum kein Anker in der Adresse: Das # gehört im CRM der Navigation
// (#/freigabe/<kennung>), ein zweites # gibt es nicht. Die Seite „Fragen“
// merkt sich deshalb die Frage, bevor sie die Besichtigung öffnet; die
// Besichtigung schaut nach dem Laden nach und rollt hin (Aufnahme.tsx). Ein
// Link in einem neuen Tab öffnet die Besichtigung eben oben.

/** Die gemerkte Frage – gilt für den nächsten Aufruf genau dieser Besichtigung. */
let ziel: { aufnahmeId: string; frageId: string } | null = null;

export function frageMerken(aufnahmeId: string, frageId: string): void {
  ziel = { aufnahmeId, frageId };
}

/** Ist für diese Besichtigung eine Frage gemerkt? Nur nachsehen – genommen wird sie mit `gemerkteFrageNehmen`. */
export function frageGemerkt(aufnahmeId: string): boolean {
  return ziel?.aufnahmeId === aufnahmeId;
}

/**
 * Die gemerkte Frage nehmen (danach ist sie vergessen). Getrennt vom
 * Nachsehen, weil React im Entwicklungsmodus jeden Effekt zweimal startet –
 * genommen wird erst, wenn wirklich gesprungen wird.
 */
export function gemerkteFrageNehmen(aufnahmeId: string): string | null {
  if (ziel?.aufnahmeId !== aufnahmeId) return null;
  const { frageId } = ziel;
  ziel = null;
  return frageId;
}

/** Die Kennung des Elements einer Frage auf der Seite (FragenAmStueck.tsx, FrageKarte). */
export function frageElementId(frageId: string): string {
  return `frage-${frageId}`;
}

/**
 * Zur Frage rollen und sie kurz aufleuchten lassen. `nachMs`: erst nach dem
 * Öffnen der großen Foto-Ansicht, die sie zeigt. Steht sie (noch) nicht da,
 * geschieht nichts.
 */
export function frageZeigen(frageId: string, nachMs = 0): void {
  window.setTimeout(() => {
    const el = document.getElementById(frageElementId(frageId));
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    el.classList.add("angesprungen");
    window.setTimeout(() => el.classList.remove("angesprungen"), 2400);
  }, nachMs);
}
